import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~shared/shadcn/ui/tooltip';
import { capitalizeWords } from '~shared/helpers/text-formatting';

import type { InstructorListCellProps } from './instructor-list-cell.types';

export function InstructorListCell({ instructors }: InstructorListCellProps) {
  const visibleInstructors = instructors.slice(0, 3);
  const remainingCount = instructors.length - 3;
  const fullNames = instructors
    .map((instructor) => instructor.name?.trim())
    .filter((name): name is string => Boolean(name))
    .map((name) => capitalizeWords(name));

  return (
    <>
      <div className='hidden flex-wrap gap-2 px-2 md:flex'>
        {visibleInstructors.map((instructor) => {
          const initials = instructor.name
            ? instructor.name
                .split(' ')
                .map((word) => word[0])
                .join('')
                .toUpperCase()
            : '';

          return (
            <TooltipProvider key={instructor._id}>
              <Tooltip>
                <TooltipTrigger>
                  <div className='flex size-8 items-center justify-center rounded-full bg-secondary text-sm font-medium text-secondary-foreground'>
                    {initials}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p className='font-medium capitalize'>{instructor.name}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          );
        })}
        {remainingCount > 0 ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <div className='flex size-8 items-center justify-center rounded-full bg-muted text-sm font-medium text-muted-foreground'>
                  +{remainingCount}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <div className='flex flex-col gap-1'>
                  {instructors.slice(3).map((instructor) => (
                    <p key={instructor._id} className='font-medium capitalize'>
                      {instructor.name}
                    </p>
                  ))}
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : null}
      </div>
      <div className='break-words px-2 text-right text-sm capitalize md:hidden'>
        {fullNames.length > 0 ? fullNames.join(', ') : '—'}
      </div>
    </>
  );
}
